interface DownloadFile {
    URL?: string;
    URLLink?: string;
    Name?: string;
    Media?: string;
    Filename?: string;
    FileLength?: number;
    ContentType?: string;
    TypeName?: string;
}

interface Props {
    file?: DownloadFile | null;
    error?: string | null;
    errorTitle?: string;
    emptyMessage?: string;
    fallbackName?: string;
    fileTypeLabel?: string;
    buttonLabel?: string;
    icon?: string;
    iconClassName?: string;
    buttonClassName?: string;
}

export const DownloadFileCard = ({
    file,
    error,
    errorTitle = "No fue posible obtener el archivo",
    emptyMessage = "No hay ningún archivo disponible para descargar",
    fallbackName = "Archivo descargable",
    fileTypeLabel,
    buttonLabel = "Descargar archivo",
    icon = "ri-file-download-line",
    iconClassName = "text-primary",
    buttonClassName = "btn-primary",
}: Props) => {
    if (error) {
        return (
            <div className="alert alert-danger mb-0" role="alert">
                <div className="d-flex align-items-start gap-2">
                    <i className="ri-error-warning-line fs-4"></i>
                    <div>
                        <strong className="d-block">{errorTitle}</strong>
                        <span>{error}</span>
                    </div>
                </div>
            </div>
        );
    }

    if (!file) {
        return (
            <div className="alert alert-warning mb-0" role="alert">
                <i className="ri-file-warning-line me-2"></i>
                {emptyMessage}
            </div>
        );
    }

    const url = file.URL ?? file.URLLink;
    if (!url) {
        return (
            <div className="alert alert-danger mb-0" role="alert">
                <i className="ri-error-warning-line me-2"></i>
                El archivo no contiene una URL de descarga válida
            </div>
        );
    }

    const fileName = file.Name ?? file.Filename ?? file.Media ?? fallbackName;
    const type = fileTypeLabel ?? file.TypeName ?? file.ContentType ?? "Archivo";

    const formatFileSize = (bytes?: number) => {
        if (!bytes) return "";
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`;
        return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
    }

    const fileSize = formatFileSize(file.FileLength);

    return (
        <div className="card border shadow-none mb-0">
            <div className="card-body d-flex flex-column flex-md-row align-items-md-center gap-3">
                <div className={iconClassName}>
                    <i className={`${icon} fs-1`}></i>
                </div>

                <div className="flex-grow-1">
                    <h5 className="mb-1">{fileName}</h5>
                    <div className="text-muted small">
                        {type}{fileSize ? ` · ${fileSize}` : ""}
                    </div>
                </div>

                <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    download={fileName}
                    className={`btn ${buttonClassName}`}
                >
                    <i className="ri-download-2-line me-1"></i>
                    {buttonLabel}
                </a>
            </div>
        </div>
    );
};
